import { SCFullscreenOverlay } from 'components/AugmentedReality/Structure/Fullscreen/styled'
import React, { useEffect } from 'react'

interface FullscreenProps {
  children: React.ReactNode;
}

const Fullscreen = ({ children }: FullscreenProps) => {

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <SCFullscreenOverlay>
      {children}
    </SCFullscreenOverlay>
  );
}

export default Fullscreen;